export const CUSTOM_REPLACE_CONTROL_ID = 'custom-replace-control';
export const CUSTOM_REPLACE_CONTROL_MARGIN = 30;
export const REPLACE_CONTROL_WIDTH = 99;
export const REPLACE_CONTROL_HEIGHT = 41;
